<template>
  <div class="home-page">
    <div v-if="$route.name==='Home'">
      <div class="home" v-if="load">
        <div class="message-info" v-if="info" v-html="info"></div>
        <div class="main">
          <h1 class="main-title">Підсумки обслуговування на {{ DateToday}}</h1>
          <div class="balance">
            <div class="block">
              <div @click="newBill()" v-tooltip.top-center="'Сформувати рахунок'" class="cart cart-link" :class="balance.balanceDay <= 2 && balance.serviceSumAvg > 0 ? 'notice' : ''">
                <span>Залишок (&#8372;): &nbsp;</span><b :class="balance.balanceDay <= 2 && balance.serviceSumAvg > 0 ? 'notice-text' : ''">{{balance.balanceMoney | toCurrency}}</b>
                <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.5 9L0.73686 0.75L10.2631 0.75L5.5 9Z"/>
                </svg>
              </div>
              <div v-tooltip.top-center="'Впродовж цих днів закінчиться поточний залишок'" class="cart" :class="balance.balanceDay <= 2 && balance.serviceSumAvg > 0 ? 'notice' : ''">
                <span>Залишок днів: &nbsp;</span><b :class="balance.balanceDay <= 2  && balance.serviceSumAvg > 0 ? 'notice-text' : ''">{{balance.balanceDay}}</b>
              </div>
              <div v-tooltip.top-center="'За період з ' + FirstMonthDay + ' по '+ DateToday + ''" class="cart">
                <span>Середня сума<br>обслуговування (&#8372;): &nbsp;</span><b>{{balance.serviceSumAvg | toCurrency}}</b>
              </div>
              <div @click="clientTrance()" v-tooltip.top-center="'За період з ' + FirstMonthDay + ' по '+ DateToday + ''" class="cart cart-link cart-sum-total">
                <span>Всього обслуговано (&#8372;):</span><b>{{balance.serviceSumTotal | toCurrency}}</b>
                <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.5 9L0.73686 0.75L10.2631 0.75L5.5 9Z"/>
                </svg>
              </div>
            </div>
            <div  class="block" v-if="$store.state.schemeType !== 0 && balance.digitalWalletRest">
              <div @click="eWallet()" v-tooltip="'Перехід до ЕГ'" class="cart cart-link">
                <span>Вільний залишок для розподілу: &nbsp;</span><b>{{balance.digitalWalletRest}}</b>
                <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.5 9L0.73686 0.75L10.2631 0.75L5.5 9Z"/>
                </svg>
              </div>
            </div>
            <div class="block-over" v-if="balance.overSum !== 0 && balance.balanceMoney < 0">
              <div class="cart"  :class="balance.overDays <= 2  ? 'notice' : ''">
                <span>Овердрафт  (₴):: &nbsp;</span><b :class="balance.overSum <= 0 ? 'notice-text' : ''">{{balance.overSum | toCurrency}}</b>
              </div>
              <div class="cart" :class="balance.overDays <= 2 ? 'notice' : ''">
                <span>Дні овердрафта:: &nbsp;</span><b :class="balance.overDays <= 2 ? 'notice-text' : ''">{{balance.overDays}}</b>
              </div>
            </div>
          </div>
          <div class="balance-mob">

              <div class="cart cart-btn" :class="balance.balanceDay <= 2 && balance.serviceSumAvg > 0 ? 'notice' : ''">
                <span>Залишок (&#8372;): &nbsp;</span><b :class="balance.balanceDay <= 2 && balance.serviceSumAvg > 0 ? 'notice-text' : ''">{{balance.balanceMoney | toCurrency}}</b>
                <button class="btn-cart" @click="newBill()" >СТВОРИТИ РАХУНОК</button>
              </div>
              <template v-if="more">
                <div class="cart cart-btn cart-sum-total">
                  <span>Всього обслуговано: за період  {{FirstMonthDay}}  по  {{DateToday}}(&#8372;)</span><b>{{balance.serviceSumTotal | toCurrency}}</b>
                  <button class="btn-cart" @click="clientTrance()" >ОБІГ ПО КЛІЄНТУ</button>
                </div>
                <div v-tooltip.top-center="'Впродовж цих днів закінчиться поточний залишок'" class="cart cart-centr" :class="balance.balanceDay <= 2 && balance.serviceSumAvg > 0 ? 'notice' : ''">
                  <span>Залишок днів: &nbsp;</span><b :class="balance.balanceDay <= 2  && balance.serviceSumAvg > 0 ? 'notice-text' : ''">{{balance.balanceDay}}</b>
                </div>
                <div class="cart">
                  <span>Середня сума обслуговування  з {{FirstMonthDay}} по {{DateToday}} (&#8372;): &nbsp;</span><b>{{balance.serviceSumAvg | toCurrency}}</b>
                </div>
                <div  class="block" v-if="$store.state.schemeType !== 0 && balance.digitalWalletRest">
                  <div class="cart">
                    <span>Вільний залишок для розподілу: &nbsp;</span><b>{{balance.digitalWalletRest}}</b>
                    <button class="btn-cart" @click="eWallet()" >Перехід до ЕГ</button>
                  </div>
                </div>
                <div class="block" v-if="balance.overSum !== 0 && balance.balanceMoney < 0">
                  <div class="cart"  :class="balance.overDays <= 2  ? 'notice' : ''">
                    <span>Овердрафт  (₴):: &nbsp;</span><b :class="balance.overSum <= 0 ? 'notice-text' : ''">{{balance.overSum | toCurrency}}</b>
                  </div>
                  <div class="cart" :class="balance.overDays <= 2 ? 'notice' : ''">
                    <span>Дні овердрафта:: &nbsp;</span><b :class="balance.overDays <= 2 ? 'notice-text' : ''">{{balance.overDays}}</b>
                  </div>
                </div>
              </template>
              <p class="more-link" @click="more=!more">{{more ? "Менше даних" : "Більше даних"}}</p>
        </div>



          <template v-if="transactions.length > 0">
            <h1 class="main-title">Транзакції за {{ DateToday }}</h1>
            <p class="main-title-mob">Транзакції за {{ DateToday }}</p>
            <main-transuction v-touch:swipe="touchHandler" :transactions="transactions"></main-transuction>
            <router-link v-if="totalCount > 3"  class="tran-link" to="/trance">ПОКАЗАТИ БІЛЬШЕ</router-link>
          </template>
        </div>
        <main-menu></main-menu>
      </div>
    </div>
    <div class="home-page">
      <router-view/>
    </div>
    <div class="footer-mob" v-if="page > Math.ceil(total.totalCount/limit)"></div>
  </div>
</template>


<script>
// @ is an alias to /src
import MainMenu from '@/components/MainMenu.vue'
import MainTransuction from "../components/MainTransuction";

// import axios from "axios";
// import router from "@/router";
import  moment from "moment";

export default {
  name: 'Home',
  components: {
     MainMenu,
    MainTransuction
  },
  filters: {

  },
  mounted(){
    fetch('https://map.svitpro.com.ua/messages-api')
        .then(stream => stream.json())
        .then(response => {
          if (response.length > 0){
            this.info = response[0].body
          }
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        })
  },
  created() {
    this.getData()
  },
  computed: {
    DateToday: function (){
      return moment().format('DD.MM.YYYY')
    },
    FirstMonthDay: function (){
      return moment().format('01.MM.YYYY')
    },
    balanceDay(){
      return this.balance.balanceDay
    },
  },
  watch: {
    balanceDay: 'showAlert'
  },
  data() {
    return {
      more: false,
      errored: false,
      load: false,
      balance: {},
      total: {},
      pageTotal: {},
      limit: 3,
      page: 1,
      transactions: [],
      totalCount: null,
      transaction: [{cardNo:"7825990000386045", transDate: "03.03.2021 3:09:01",  transSum:"2 999,00", station: "ОККО, Одеська, Одеса, Балківська, 115" },
                 {cardNo:"7825990000386045", transDate: "03.03.2021 3:09:01",  transSum:"2 999,00", station: "ОККО, Одеська, Одеса, Балківська, 115" },
        {cardNo:"7825990000386045", transDate: "03.03.2021 3:09:01",  transSum:"2 999,00", station: "ОККО, Одеська, Одеса, Балківська, 115" }
      ],
      info: null
    }
  },
  methods: {
    touchHandler: function () {
      // console.log('tap')
      this.page = this.page + 1
      // console.log(this.page)
      if (this.page <= Math.ceil(this.total.totalCount/this.limit)) {
        this.axios.get('/userservice/v1/User/transactions-simple', {params: {topTransactions: this.limit, page: this.page}})
            .then(response => (
                    this.transactions = this.transactions.concat.apply(this.transactions, response.data.data),
                        this.total =  response.data.total,
                        this.pageTotal =  response.data.pageTotal
                )
            ).catch(error => {
          console.log('error_get_data');
          console.log(error);
          this.errored = true;
        })
            .finally(() => (
                this.load = true)
            )
      }

    },
    eWallet: function () {
      this.$router.push('/reports/e-wallet');
    },
    newBill: function (){
      this.$router.push('/reports/cbills');
    },
    clientTrance: function (){
      this.$router.push('/service-results');
    },
    getData: function (){
      this.axios.all([
        this.axios.get('/userservice/v1/User/transactions-simple', {params: {topTransactions: 3}}),
        this.axios.get('/userservice/v1/User/balance-simple'),
        //this.axios.get('https://map.svitpro.com.ua/messages-api')
       ]).then(
          this.axios.spread((transactions, balance) => {
            this.balance = balance.data
            this.transactions = transactions.data.data
            this.totalCount = transactions.data.total.totalCount
            this.total =  transactions.data.total,
            this.pageTotal =  transactions.data.pageTotal
          //  this.info = info.data
          })
          )
          .catch(error => {
              console.log('error_get_data');
              console.log(error);
              this.errored = true;
          })
          .finally(() => (
              this.load = true)
          )
    },
    showAlert() {
      if (this.balanceDay <=2 && this.balance.serviceSumAvg > 0) {
        // Use sweetalert2
        this.$swal.fire(
            {
              title: 'Зверніть УВАГУ!',
              text: 'Критичний залишок балансу',
              confirmButtonText: "ЗРОЗУМІЛО",
              showCloseButton: true,
              buttonsStyling: false,
              width: '390px',
              height: '191px'
            });
      }
    },
  }
}

</script>
<style>
.home-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.tran-link{
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
  /* or 146% */
  text-transform: uppercase;
  font-feature-settings: 'cpsp' on;
  color: var(--main-blue);
  letter-spacing: 1px;
}
.balance {
 /* width: 100%; 1344px;*/
  margin-top: 47px;
  margin-bottom: 57px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  //display: grid; /* 1 */
  //grid-template-columns: repeat(auto-fit, 262px); /* 2 */
  //grid-column-gap: 3%; /* 3 */

}


.cart {
  //min-width: 262px;
  width: 23%;
  min-height: 74px;
  //max-height: 100px;
  border: 1px solid #C4C4C4;
  box-sizing: border-box;
  margin-top: 6px;
  margin-bottom: 7px;
  //margin-left: 31px;
  //margin-right: 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  position: relative;
  padding: 10px;
  flex-wrap: wrap;
}

.cart-sum-total{
  //flex-direction: column;
  margin-right: 0px;
  //flex-grow: 1;
}
.cart-sum-total b {
  //margin-top: 8px;
}
.cart b.notice-text {
  color: var(--red-notice);
}
.notice {
  border: 1px solid var(--red-notice);
}
.cart svg {
   position: absolute;
   right: 11px;
}
.cart span {
  font-family: Roboto,arial,sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 19px;
  /* or 146% */
  font-feature-settings: 'cpsp' on;
  color: var(--usual-black);
  margin-top: 2px;
}
.cart b {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 35px;
  /* or 63% */
  font-feature-settings: 'cpsp' on;
  margin-right: 20px;
  color: var(--main-blue);

}
.main{
  width: 80%; /* 1139px; */
  text-align: left;
  margin-bottom: 51px;
  flex-grow: 1;
//align-self: start;
//margin-left: 150px;
}
.block {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}
.block-over {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.home {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  flex-grow: 1;
}
.message-info {
  width: 80%;/* 1139px;*/
  /*height: 199px;*/
  background: rgba(78, 76, 199, 0.2);
  padding-left: 97px;
  padding-right: 88px;
  padding-top: 45px;
  padding-bottom: 22px;
  margin-bottom: 55px;
  box-sizing: border-box;
}
.message-info h1 {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 19px;
  /* identical to box height, or 63% */
  color: var(--main-blue);
  margin-bottom: 31px;
}
.message-info p {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 32px;
  /* or 160% */
  color: var(--main-blue);
}
.cart-link {
  background-color: var(--active-purple);
}
.cart-link:hover {
 border: 1px solid var(--soft-purple);
}
.cart-link:hover b {
  color: var(--soft-purple);
}
.cart-link:hover svg {
  fill: var(--soft-purple);
}
.cart-link svg {
  fill: var(--main-blue);
}
.balance-mob {
  display: none;
}
.btn-cart {
  width: 231px;
  height: 54px;
  background: var(--soft-purple);
  border-radius: 20px;
  outline: none;
  border: none;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
  /* identical to box height, or 146% */

  text-align: center;
  text-transform: uppercase;
  font-feature-settings: 'cpsp' on;
  margin: 20px;
  color: #FFFFFF;
}
.more-link {
  margin-left: auto;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 19px;
  /* or 127% */
  text-align: right;
  font-feature-settings: 'cpsp' on;
  color: #222160;
}
.main-title-mob {
  display: none;
}
@media  (max-width: 1040px)  and (orientation: portrait) {
  .footer-mob {
    display: block;
    height: 25px;
    background: var(--main-blue);
  }
  .main {
    width: 80%;
  }
  .cart {
    margin-right: 0;
  }
  .main-title, .balance, .tran-link{
    display: none;
  }
  .balance-mob {
    margin-top: 47px;
    margin-bottom: 57px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .balance-mob .cart-btn {
    padding:15px;
    //box-sizing: content-box;

  }
  .balance-mob .cart {
    max-height: none;
    //min-width: 313px;
    width: 100%;
  }
  .balance-mob .cart span {
    font-family: Roboto,arial,sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 19px;
    /* identical to box height, or 127% */
    font-feature-settings: 'cpsp' on;
    color: #000000;
    text-align: center;
  }
  .main-title-mob{
    display: inline;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 18px;
    /* or 90% */
    color: #222160;
  }
}
@media ( max-width: 1040px)  and (orientation: landscape) {
  .footer-mob {
    display: block;
    height: 25px;
    background: var(--main-blue);
  }
  .main {
    width: 80%;
  }
  .cart {
    margin-right: 0;
  }
  .main-title, .balance, .tran-link{
    display: none;
  }
  .balance-mob {
    margin-top: 47px;
    margin-bottom: 57px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .balance-mob .cart-btn {
    padding:15px;
  //box-sizing: content-box;

  }
  .balance-mob .cart {
    max-height: none;
    min-width: 500px;
    width: 100%;
    flex-wrap: nowrap;
    justify-content: start;
  }
  .balance-mob .cart span {
    font-family: Roboto,arial,sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 19px;
    /* identical to box height, or 127% */
    font-feature-settings: 'cpsp' on;
    color: #000000;
    //text-align: center;
  }
  .main-title-mob{
    display: inline;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 18px;
    /* or 90% */
    color: #222160;
  }
}

</style>